import React from 'react'

import { Flex } from 'pcln-design-system'

import { VIP_COLORS } from '../colorVariations'

import { TdContent, VipIncludedMaterialResponsive } from './styledComponents'

const BenefitsTableCell = ({ row, vipTierName }) => {
  const colData = row[vipTierName]

  if (!colData) {
    return null
  }

  return (
    <Flex alignItems='center'>
      <VipIncludedMaterialResponsive fillColor={VIP_COLORS[vipTierName]} />
      <TdContent>{colData}</TdContent>
    </Flex>
  )
}

export { BenefitsTableCell }
